var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.5227 24.1779H49.8285V18.9904C49.8285 11.4263 44.2931 4.6738 36.7581 3.94927C28.1218 3.13781 20.8476 9.91934 20.8476 18.3818V24.1779H12.1533V64.7512H58.5227V24.1779ZM35.338 50.2607C32.1501 50.2607 29.5419 47.6525 29.5419 44.4646C29.5419 41.2767 32.1501 38.6684 35.338 38.6684C38.5259 38.6684 41.1342 41.2767 41.1342 44.4646C41.1342 47.6525 38.5259 50.2607 35.338 50.2607ZM26.6438 24.1779V18.3818C26.6438 13.5709 30.5272 9.68749 35.338 9.68749C40.1489 9.68749 44.0323 13.5709 44.0323 18.3818V24.1779H26.6438Z",
    fill: "#848484"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.b7d62cd6b197936ecfd2b34d9e5c4994.svg";
export { ForwardRef as ReactComponent };